import React from 'react';
import { observer } from 'mobx-react';
import { useRootStore } from '~/stores/useRootStore';
import SessionConfigsDropDown from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/SessionConfigsDropDown';
import { IAutomationTriggerFilterTypes } from '~/types/automation.types';
import { AUTOMATION_TRIGGER_EVENTS } from '~/utils/automation.utils';
import TemplateConfigsDropDown from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/TemplateConfigsDropDown';

const TRIGGER_FILTER_COMPONENTS_MAP: Record<
    IAutomationTriggerFilterTypes,
    Function
> = {
    session_configs: SessionConfigsDropDown,
    templates: TemplateConfigsDropDown
};

const AutomationTriggerFilters = () => {
    const {
        automationUiStore: {
            selectedStep: {
                workflow_step_trigger: { trigger_type }
            }
        }
    } = useRootStore();

    const triggerConfig = AUTOMATION_TRIGGER_EVENTS.find(
        t => t.value === trigger_type
    );

    if (!triggerConfig?.filters) {
        return null;
    }

    return (
        <>
            {triggerConfig.filters.map(key => {
                const FilterComponent = TRIGGER_FILTER_COMPONENTS_MAP[key];
                return <FilterComponent key={key} />;
            })}
        </>
    );
};

export default observer(AutomationTriggerFilters);
